module.exports = __webpack_public_path__ + "static/img/page_15.c35615e6.png";